import React from "react";
import { useNavigate } from "react-router-dom";

export default function Stepper({
  labels = ["Setup",  "Questions", "Review"],
  activeIndex = 0,
  paths = null,
  onStepClick = null,
  allowFutureClick = false,
}) {
  const PURPLE = "#2E2868";
  const LIGHT = "#cfc9f2";
  const ACTIVE = "#2E2868";
  const navigate = useNavigate();

 
  const steps = labels.length;

  const handleClick = (idx) => {
    if (!allowFutureClick && idx > activeIndex) return;
    if (onStepClick) onStepClick(idx);
    else if (paths && paths[idx]) navigate(paths[idx]);s
  };

  return (
    <div style={{ display: "inline-block", width: "400px" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* background line */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "7px",
            right: "7px",
            height: "2px",
            background: LIGHT,
            zIndex: 0,
            transform: "translateY(-50%)",
          }}
        />
        {/* progress line */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "7px",
            width: `calc(${(activeIndex / (steps - 1)) * 100}% - 7px)`,
            height: "2px",
            background: PURPLE,
            zIndex: 1,
            transform: "translateY(-50%)",
            transition: "width 0.3s ease",
          }}
        />

        {/* dots */}
        {Array.from({ length: steps }).map((_, i) => (
          <div
            key={i}
            style={{
              width: 19,
              height: 19,
              borderRadius: "50%",
              background: i <= activeIndex ? ACTIVE : "#fff",
              border: `2px solid ${PURPLE}`,
              zIndex: 2,
            }}
          />
        ))}
      </div>

      {/* labels under steps */}
      <div
        style={{
          marginTop: 6,
          color: "#6c6f82",
          fontSize: 14,
          display: "grid",
          gridTemplateColumns: `repeat(${steps}, 1fr)`,
          textAlign: "center",
        }}
      >
        {labels.map((lbl, i) => {
          const canClick = allowFutureClick || i <= activeIndex;
          return (
            <span
              key={lbl}
              onClick={() => handleClick(i)}
              style={{
                cursor: canClick ? "pointer" : "default",
                color: i <= activeIndex ? PURPLE : "#6c6f82",
                fontWeight: i === activeIndex ? 600 : 400,
                userSelect: "none",
              }}
            >
              {lbl}
            </span>
          );
        })}
      </div>
    </div>
  );
}
